export const REASON_STAGES = ['ArchivedStage', 'RejectedStage'];

export const DEFAULT_MOVE_RULE = {
  target_stage_id: undefined,
  idle_days_count: 3,
  enable_move_to_notifications: false,
  ignore_applicant_action: false,
};
